module.exports = __webpack_public_path__ + "static/media/office.30da6423.svg";